import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Template } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useTemplate = (
  projectId: string,
  notiflowId: string,
  notiflowStepId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Template>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Template>({
    queryKey: ["projects", projectId, "notiflows", notiflowId, "steps", notiflowStepId, "template"],
    queryFn: async (): Promise<Template> => {
      const response = await api.get<Template>(`/projects/${projectId}/notiflows/${notiflowId}/steps/${notiflowStepId}/template`);
      return camelize(response.data);
    },
    ...options
  });
};
